import type { AxiosInstance } from "axios";
import {
  getAccessToken,
  getAffiliateId,
  requestReauthentication,
} from "@/auth/authStore";
import { getApiBaseUrl } from "@/lib/config";
import { createApiClient } from "./client";

let client: AxiosInstance | null = null;

/**
 * Returns the app-wide API client, creating it on first use.
 *
 * The client is wired to the {@link getAccessToken auth store}, so every request
 * uses the current bearer token and affiliate, and a 401 triggers
 * {@link requestReauthentication}. It is created lazily (not at import) so tests
 * and the production build do not need the API environment to be present just to
 * load this module.
 */
export function getApiClient(): AxiosInstance {
  if (client === null) {
    client = createApiClient({
      apiBaseUrl: getApiBaseUrl(),
      getAccessToken,
      getAffiliateId,
      onUnauthorized: requestReauthentication,
    });
  }
  return client;
}

/** Discards the cached client. Intended for tests so each gets a clean instance. */
export function resetApiClient(): void {
  client = null;
}
